import { Tooltip, TooltipProps } from '@material-ui/core';

import React, { ReactElement } from 'react';
import { TKey, usePublicaTranslation } from '~/src/dash/publicaUI';
import { ITProps } from '~/src/dash/publicaUI';

interface IProps extends Partial<TooltipProps> {
  tKey?: TKey;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tProps?: ITProps;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any, any>;
}

export const TooltipWithTranslation = (props: IProps): React.JSX.Element => {
  const { t } = usePublicaTranslation();

  const { tKey, tProps, ...tooltipProps } = props;
  const title = tKey ? t(tKey, tProps) : props?.title || '';
  return <Tooltip {...tooltipProps} title={title} />;
};
